module.exports = __webpack_public_path__ + "static/PMCN-7db0df2fd744c5835629d755af277826.png";